<template>
    <b-modal :visible="showAdminModal === 'addEditInternalNumber'" size="lg" @hidden="hideModal" :lazy="true">
        <div slot="modal-title">
            <h4 class="modal-title" v-if="item">Изменить внутренний номер {{item.number}}</h4>
            <h4 class="modal-title" v-else>Добавить внутренний номер</h4>
        </div>
        <loading v-if="loading" :size="3" message="Сохраняем..."></loading>
        <form v-else>
            <div class="form-group row" :class="{ 'has-danger': $v.newDataItem.number.$error }">
                <label for="item-number" class="col-4 col-form-label">Номер телефона</label>
                <div class="col-8">
                    <input class="form-control" type="text" id="item-number" v-model.trim="newDataItem.number" @input="$v.newDataItem.number.$touch()">
                    <span class="small help-block text-danger" v-if="$v.newDataItem.number.$error">Внутренний номер должн быть указан и состоять из {{$v.newDataItem.number.$params.minLength.min}} цифр</span>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-4 form-control-label">Пользователи</label>
                <div class="col-8">
                    <multiselect
                            :options="users"
                            :searchable="true"
                            :multiple="true"
                            :close-on-select="true"
                            :show-labels="false"
                            v-model="selectedUsers"
                            placeholder="Пользователи не заданы"
                            track-by="id" label="fullname"
                            @select="attachUser"
                            @remove="detachUser"
                            @open="loadUsers"
                            :loading="loadingUsers"
                    >
                    </multiselect>
                </div>
            </div>
        </form>
        <div slot="modal-footer">
            <button v-if="!loading" :class="{ 'disabled': $v.newDataItem.$invalid }" :disabled="$v.newDataItem.$invalid" type="button" class="btn btn-success" @click.prevent="beforeUpdateForm">
                <template v-if="item">Сохранить изменения</template>
                <template v-else>Добавить внутренний номер</template>
            </button>
        </div>
    </b-modal>
</template>
<script>
  import { required, minLength, numeric, maxLength } from 'vuelidate/lib/validators'
  import addInternalNumberMutate from './../../gql/mutations/PBX/AddInternalNumber.graphql'
  import UpdateInternalNumberMutate from './../../gql/mutations/PBX/UpdateInternalNumber.graphql'
  import { mapState, mapActions } from 'vuex'
  import Multiselect from 'vue-multiselect'
  import { ADD_TOAST_MESSAGE } from 'vuex-toast'
  import getUsers from './../../gql/queries/getUsersForMultiselect.graphql'
  export default {
    computed: {
      ...mapState({
        showAdminModal: state => state.adminStore.showModal,
        item: state => state.adminStore.editInternalNumber
      })
    },
    watch: {
      showAdminModal: function (val) {
        if (val === 'addEditInternalNumber' && this.item) {
          this.setNewDataItem()
        }
        if (val === 'addEditInternalNumber' && !this.item) {
          this.clearData()
        }
      }
    },
    data () {
      return {
        loading: false,
        newDataItem: {
          id: null,
          number: '',
          users: []
        },
        loadingUsers: false,
        users: [],
        selectedUsers: null
      }
    },
    methods: {
      setNewDataItem () {
        const item = this.item
        this.newDataItem = Object.assign({}, item)
        this.selectedUsers = item.users
        this.newDataItem.users = []
        if (item.users) {
          item.users.forEach((user) => {
            this.newDataItem.users.push(user.id)
          })
        }
      },
      beforeUpdateForm () {
        this.$v.newDataItem.$touch()
        if (this.$v.newDataItem.$error) {
          return
        }
        if (this.item) {
          this.updateItem()
        } else {
          this.addItem()
        }
      },
      addItem () {
        this.loading = true
        this.$apollo.mutate({
          mutation: addInternalNumberMutate,
          variables: this.newDataItem
        }).then((data) => {
          this.loading = false
          this.addToast({
            text: 'Внутренний номер успешно добавлен',
            type: 'success',
            dismissAfter: 3000
          })
          this.hideModal()
        }).catch((error) => {
          console.error(error)
          this.addToast({
            text: 'Произошла ошибка:' + error,
            type: 'danger',
            dismissAfter: 10000
          })
          this.loading = false
        })
      },
      updateItem () {
        this.loading = true
        this.$apollo.mutate({
          mutation: UpdateInternalNumberMutate,
          variables: this.newDataItem
        }).then((data) => {
          this.loading = false
          this.addToast({
            text: 'Внутренний успешно обновлен',
            type: 'success',
            dismissAfter: 3000
          })
          this.hideModal()
        }).catch((error) => {
          console.error(error)
          this.addToast({
            text: 'Произошла ошибка:' + error,
            type: 'danger',
            dismissAfter: 10000
          })
          this.loading = false
        })
      },
      hideModal () {
        this.clearData()
        this.$store.commit('SET_ADMIN_EDIT_INTERNAL_NUMBER', null)
        this.$store.dispatch('setAdminModal', false)
      },
      ...mapActions({
        addToast: ADD_TOAST_MESSAGE
      }),
      clearData () {
        this.newDataItem = {
          id: null,
          number: '',
          users: []
        }
        this.$v.newDataItem.$reset()
        this.selectedUsers = null
      },
      /**
       * Подргрузка менеджеров
       * активируется при открытии селекта
       */
      loadUsers () {
        this.loadingUsers = true
        this.$apollo.query({
          query: getUsers
        }).then(result => {
          this.users = result.data.users
          this.loadingUsers = false
        }).catch(error => {
          console.log(error)
          this.loadingUsers = false
        })
      },
      attachUser (user) {
        this.newDataItem.users.push(user.id)
      },
      detachUser (user) {
        let index = this.newDataItem.users.indexOf(user.id)
        this.newDataItem.users.splice(index, 1)
      }
    },
    components: {
      Multiselect
    },
    validations: {
      newDataItem: {
        number: {
          required,
          numeric,
          minLength: minLength(3),
          maxLength: maxLength(3)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ModalAdminAddEditInternalNumber.vue?bebf2096